module.exports = __webpack_public_path__ + "img/NSkirmisher64_ua.747f70bd.webp";